import { Grid, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { StepOneFormOmboarding } from './StepOneFormOmboarding';

export const CompleteOmboardingOne = ({ setstepper, stepper, setSteppercolor }) => {
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'stepper personal data',
        path: '/completeregistration',
        link: {
          url: '/completeregistration',
          title: 'stepper personal data',
        },
      },
    });
  }, []);
  return (
    <>
      <Grid container maxWidth='sm' spacing={2} marginBottom={'20px'}>
        <Grid item md={12} className='stepper-grid-registration'>
          <Typography variant='h6' className='blue_text fw-600 font-lg-24'>
            Datos personales
          </Typography>
        </Grid>
      </Grid>
      <Stack spacing={2}>
        <StepOneFormOmboarding
          setstepper={setstepper}
          stepper={stepper}
          setSteppercolor={setSteppercolor}
        />
      </Stack>
    </>
  );
};
